import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var numFormatter = function numFormatter(num) {
  if (num >= 1000000) {
    return "".concat((num / 1000000).toFixed(1).replace(/\.0$/, ''), "M");
  }
  if (num >= 1000) {
    return "".concat((num / 1000).toFixed(1).replace(/\.0$/, ''), "K");
  }
  return num;
};